import { render } from "./LastViewed.vue?vue&type=template&id=4f0b0d3e"
import script from "./LastViewed.vue?vue&type=script&lang=js"
export * from "./LastViewed.vue?vue&type=script&lang=js"

import "./LastViewed.vue?vue&type=style&index=0&id=4f0b0d3e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__